












































































































import Vue from 'vue'
import { defaultPosterImage, userAvatarImage } from '../../helper/constants'
import UpsellModal from '@/components/common/UpsellModal.vue'
let openedWindow: Window | null
export default Vue.extend({
  components: { UpsellModal },
  props: {
    upsellId: {
      type: String
    },
    offer: {
      type: Object
    },
    purchasedProductIds: {
      type: Array
    }
  },
  data() {
    return {
      userAvatarImage,
      defaultPosterImage,
      isMobile: false,
      showModal: false,
      height: '108px'
    }
  },
  mounted() {
    this.isMobile = screen.width < 760
    this.setCardHeight()
    window.addEventListener('resize', this.setCardHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setCardHeight)
  },
  filters: {
    truncateText(text: string, MAX_LENGTH = 28): string {
      if (text?.length < MAX_LENGTH) return text

      return text ? text?.slice(0, MAX_LENGTH) + '...' : ''
    }
  },
  computed: {
    courseData(): object {
      if (this.offer?.products?.length === 1) {
        const product = this.offer.products[0]
        return {
          title: product.title,
          posterImage: product.posterImage,
          description: this.$options.filters.truncateText(
            product.description,
            75
          ),
          instructorName:
            product.customizations?.instructorName || 'Instructor Name',
          instructorHeadshot: product.customizations?.instructorHeadshot
        }
      } else {
        return {
          title: this.offer.title,
          posterImage: this.offer.posterImage,
          description: this.$options.filters.truncateText(
            this.offer.description,
            75
          ),
          instructorName: 'Multiple Instructors',
          instructorHeadshot: null
        }
      }
    },
    backgroundImage(): string {
      return `url(${this.$options.filters.replaceBucketUrlWithCdnUrl(
        this.courseData.posterImage || defaultPosterImage
      )})`
    }
  },
  methods: {
    openUpsell() {
      if (this.offer?.products?.length == 1) {
        this.handleUpsellCheckout()
      } else {
        this.showModal = true
        return
      }
    },
    handleUpsellCheckout() {
      const routerData = this.$router.resolve({
        name: 'in-app-upsell',
        params: {
          id: this.upsellId
        }
      })
      openedWindow = window.open(routerData.href, '_blank')
      const timer = setInterval(async () => {
        if (openedWindow.closed) {
          clearInterval(timer)
          window.location.reload()
        }
      }, 500)
    },
    setCardHeight() {
      const imageContainer = document.querySelector(
        '.product-image'
      ) as HTMLElement
      this.height = imageContainer.offsetWidth / 1.77 + 'px'
    }
  }
})
